/*
 * Upload
 * 文件和图片上传
 * created by 李帅
 */
import RooUpload from './Upload';
export * from './interface';
export default RooUpload;